import { Component, Input } from '@angular/core';

import { asPaxTypeKey } from '@fcom/dapi/utils';
import { FinnairFrequentFlyerCardItem, FinnairPassengerItem } from '@fcom/dapi/api/models';
import { FrequentFlyerTierLevel } from '@fcom/manage-booking/enums';
import { FREQUENT_FLIER_AIRLINES } from '@fcom/utils';

@Component({
  selector: 'fin-passenger-review-item',
  templateUrl: 'passenger-review-item.component.html',
})
export class PassengerReviewItemComponent {
  public readonly asPaxTypeKey = asPaxTypeKey;

  @Input()
  passenger: FinnairPassengerItem;

  @Input()
  accompanyingAdult: FinnairPassengerItem;

  @Input()
  accompanyingInfant: FinnairPassengerItem;

  @Input()
  showEmpty: boolean;

  @Input()
  showEtickets = false;

  getFrequentFlyerLabel(card: FinnairFrequentFlyerCardItem): string {
    const companyCode = card.companyCode.toLowerCase();
    const tierBaseLabel = 'finnairPlus.tier';
    const companyBaseLabel = 'purchase.review.frequentFlyer';

    if (companyCode !== 'ay') {
      if (FREQUENT_FLIER_AIRLINES.find(({ code }) => code.toLowerCase() === companyCode)) {
        return `${companyBaseLabel}.${companyCode}`;
      }
      return `${companyBaseLabel}.default`;
    }

    switch (card.tierLevel) {
      case FrequentFlyerTierLevel.PLUS:
        return `${tierBaseLabel}.basic`;
      case FrequentFlyerTierLevel.SILVER:
        return `${tierBaseLabel}.silver`;
      case FrequentFlyerTierLevel.GOLD:
        return `${tierBaseLabel}.gold`;
      case FrequentFlyerTierLevel.PLATINUM:
        return `${tierBaseLabel}.platinum`;
      case FrequentFlyerTierLevel.LUMO:
        return `${tierBaseLabel}.lumo`;
      case FrequentFlyerTierLevel.JUNIOR:
        return `${tierBaseLabel}.junior`;
      default:
        return `${companyBaseLabel}.ay`;
    }
  }
}
